import React from 'react'

const ShippingOne = () => {
    return (
        <section className="shipping mb-24" id="shipping">
            <div className="container container-lg">
                <div className="row gy-4">
                    <div className="col-xxl-3 col-sm-6">
                        <div className="shipping-item flex-align gap-12 gap-md-16 rounded-16 bg-main-50 hover-bg-main-100 transition-2"
                             style={{ padding: 'clamp(1rem, 3vw, 1.25rem)' }}>
                            <span className="flex-center rounded-circle bg-main-600 text-white flex-shrink-0"
                                  style={{ 
                                      width: 'clamp(40px, 8vw, 56px)', 
                                      height: 'clamp(40px, 8vw, 56px)',
                                      fontSize: 'clamp(20px, 4vw, 32px)'
                                  }}>
                                <i className="ph-fill ph-leaf" />
                            </span>
                            <div className="">
                                <h6 className="mb-0" style={{ fontSize: 'clamp(14px, 3vw, 16px)' }}>Her gün taze</h6>
                                <span className="text-sm text-heading" style={{ fontSize: 'clamp(12px, 2.5vw, 14px)' }}>
                                    10kg üzeri siparişlerde ücretsiz kargo
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="col-xxl-3 col-sm-6">
                        <div className="shipping-item flex-align gap-12 gap-md-16 rounded-16 bg-main-50 hover-bg-main-100 transition-2"
                             style={{ padding: 'clamp(1rem, 3vw, 1.25rem)' }}>
                            <span className="flex-center rounded-circle bg-main-600 text-white flex-shrink-0"
                                  style={{ 
                                      width: 'clamp(40px, 8vw, 56px)', 
                                      height: 'clamp(40px, 8vw, 56px)',
                                      fontSize: 'clamp(20px, 4vw, 32px)'
                                  }}>
                                <i className="ph-fill ph-hand-heart" />
                            </span>
                            <div className="">
                                <h6 className="mb-0" style={{ fontSize: 'clamp(14px, 3vw, 16px)' }}>%100 Memnuniyet</h6>
                                <span className="text-sm text-heading" style={{ fontSize: 'clamp(12px, 2.5vw, 14px)' }}>
                                    Güvenli alışveriş garantisi
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="col-xxl-3 col-sm-6">
                        <div className="shipping-item flex-align gap-12 gap-md-16 rounded-16 bg-main-50 hover-bg-main-100 transition-2"
                             style={{ padding: 'clamp(1rem, 3vw, 1.25rem)' }}>
                            <span className="flex-center rounded-circle bg-main-600 text-white flex-shrink-0"
                                  style={{ 
                                      width: 'clamp(40px, 8vw, 56px)', 
                                      height: 'clamp(40px, 8vw, 56px)',
                                      fontSize: 'clamp(20px, 4vw, 32px)'
                                  }}>
                                <i className="ph-fill ph-credit-card" />
                            </span>
                            <div className="">
                                <h6 className="mb-0" style={{ fontSize: 'clamp(14px, 3vw, 16px)' }}>Güvenli Ödeme</h6>
                                <span className="text-sm text-heading" style={{ fontSize: 'clamp(12px, 2.5vw, 14px)' }}>
                                    SSL sertifikalı güvenli ödeme
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="col-xxl-3 col-sm-6">
                        <div className="shipping-item flex-align gap-12 gap-md-16 rounded-16 bg-main-50 hover-bg-main-100 transition-2"
                             style={{ padding: 'clamp(1rem, 3vw, 1.25rem)' }}>
                            <span className="flex-center rounded-circle bg-main-600 text-white flex-shrink-0"
                                  style={{ 
                                      width: 'clamp(40px, 8vw, 56px)', 
                                      height: 'clamp(40px, 8vw, 56px)',
                                      fontSize: 'clamp(20px, 4vw, 32px)'
                                  }}>
                                <i className="ph-fill ph-chats" />
                            </span>
                            <div className="">
                                <h6 className="mb-0" style={{ fontSize: 'clamp(14px, 3vw, 16px)' }}>7/24 Destek</h6>
                                <span className="text-sm text-heading" style={{ fontSize: 'clamp(12px, 2.5vw, 14px)' }}>
                                    Her zaman yanınızdayız
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    )
}

export default ShippingOne